import { FC } from "react";

import { Box, Stack, useTheme } from "@mui/material";

import { ZeffyConfetti } from "@/components/Animations/ZeffyConfetti/ZeffyConfetti";

type ShareFormTabLayoutProps = {
  withConfetti?: boolean;
  slots: {
    closeButton: React.ReactNode;
    header: React.ReactNode;
    content?: React.ReactNode;
    footer?: React.ReactNode;
  };
};

export const ShareFormTabLayout: FC<ShareFormTabLayoutProps> = ({ withConfetti = false, slots }) => {
  const theme = useTheme();

  return (
    // eslint-disable-next-line zeffy-linter-frontend/avoid-vh
    <Stack width="100%" maxHeight={{ xs: "90vh", md: "auto" }}>
      <Stack
        alignItems="flex-end"
        padding={theme.spacing(3, 3, 4, 3)}
        sx={{ position: "relative", backgroundColor: theme.palette.surface.brand.intense }}
      >
        {withConfetti && <ZeffyConfetti canLoadData />}
        {slots.closeButton}
        <Box width="100%" maxWidth="550px" marginInline="auto">
          {slots.header}
        </Box>
      </Stack>
      {slots.content && (
        <Box padding={theme.spacing(3, 3, slots.footer ? 0 : 3, 3)} sx={{ flex: "1 1 auto", overflowY: "auto" }}>
          {slots.content}
        </Box>
      )}
      {slots.footer && (
        <Box data-test="share-form-modal-footer" padding={theme.spacing(slots.content ? 2 : 3, 3, 3, 3)}>
          {slots.footer}
        </Box>
      )}
    </Stack>
  );
};
